module.exports = __webpack_public_path__ + "profitoro_logo.svg?f363a5a18f1c1b0b8d377d5545359797";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profitoro_logo.svg
// module id = 34
// module chunks = 0